import styled from 'styled-components'
import breakpoints from '../../../../config/Breakpoints'
import CardTitle from '../../../../common/styles/CardTitle'
import useReadingSpeedRanking from '../hooks/useReadingSpeedRanking'
import LoadingBar from '../../../../common/LoadingBar'
import {useState} from 'react'
import NoContent from '../../../../common/NoContent'

const formatHours = (hours: number): string => {
	if (hours >= 100) {
		return `${Math.round(hours)}시간`
	}
	if (hours >= 1) {
		return `${hours.toFixed(1)}시간`
	}
	const minutes = Math.round(hours * 60)
	return `${minutes}분`
}

const BookStatisticsReadingSpeedCard = () => {
	const [data, isLoading] = useReadingSpeedRanking()
	const [tab, setTab] = useState<'fastest' | 'slowest'>('fastest')

	const list = tab === 'fastest' ? data?.fastest : data?.slowest

	return (
		<Container>
				<CardTitle icon={null} mb={0} title={'완독 속도 순위'} url={''} textSize={5}/>

				<TabContainer>
					<Tab $active={tab === 'fastest'} onClick={() => setTab('fastest')}>빨리 읽은 책</Tab>
					<Tab $active={tab === 'slowest'} onClick={() => setTab('slowest')}>오래 읽은 책</Tab>
				</TabContainer>

				{isLoading ? (
					<RankList>
						{Array.from({length: 10}).map((_, i) => (
							<LoadingItem key={i}>
								<Rank>{i + 1}</Rank>
								<LoadingCover/>
								<LoadingBar size={3}/>
							</LoadingItem>
						))}
					</RankList>
				) : list && list.length > 0 ? (
					<RankList>
						{list.map((item, index) => (
							<RankItem key={index} href={`/book/mine/${item.book.id}`}>
								<Rank>{index + 1}</Rank>
								{item.book.cover && <BookCover src={item.book.cover} alt={''}/>}
								<BookTitle className={'clamp-1-line'}>{item.book.title}</BookTitle>
								<Days>{formatHours(item.totalReadTimeInHours)}</Days>
							</RankItem>
						))}
					</RankList>
				) : (
					<CenterContainer>
						<NoContent message={'데이터가 없어요'}/>
					</CenterContainer>
				)}
		</Container>
	)
}

const Container = styled.div`
	height: 100%;
	min-height: 650px;
	background-color: var(--card-bg-color);
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	padding: 25px;
	display: flex;
	flex-direction: column;

	@media (max-width: ${breakpoints.md}) {
		height: auto;
		min-height: 0;
	}
`

const CenterContainer = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
`

const TabContainer = styled.div`
	display: flex;
	gap: 10px;
	margin-bottom: 15px;
`

const Tab = styled.button<{$active: boolean}>`
	flex: 1;
	padding: 8px;
	border: none;
	border-radius: 8px;
	background-color: ${({$active}) => $active ? '#1cb15a' : 'var(--card-bg-color)'};
	color: ${({$active}) => $active ? 'white' : 'var(--text-color)'};
	font-weight: ${({$active}) => $active ? 'bold' : 'normal'};
	cursor: pointer;
	transition: all 0.2s;
`

const LoadingItem = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 8px;
	border-bottom: 1px solid var(--hover-bg-color);

	&:last-child {
		border-bottom: none;
	}
`

const LoadingCover = styled.div`
	width: 30px;
	height: 42px;
	border-radius: 3px;
	background-color: var(--hover-bg-color);
`

const RankList = styled.div`
	display: flex;
	flex-direction: column;
`

const RankItem = styled.a`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 8px;
	text-decoration: none;
	color: var(--text-color);
	border-bottom: 1px solid var(--hover-bg-color);

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		background-color: var(--hover-bg-color);
		color: var(--text-color);
	}
`

const Rank = styled.span`
	min-width: 24px;
	font-weight: bold;
	color: var(--sub-text-color);
	text-align: center;
`

const BookCover = styled.img`
	width: 30px;
	height: 42px;
	object-fit: cover;
	border-radius: 3px;
`

const BookTitle = styled.span`
	flex: 1;
`

const Days = styled.span`
	color: var(--sub-text-color);
	font-size: 14px;
	white-space: nowrap;
`

export default BookStatisticsReadingSpeedCard
